import React from 'react';
import { useAuth } from '../context/AuthContext';

export default function SuspendedBanner() {
  const { user } = useAuth();
  if (user?.team_status !== 'suspended') return null;

  return (
    <div style={{ background: 'var(--error-bg)', border: '1px solid var(--error)', borderRadius: 12, padding: '14px 20px', marginBottom: 16, color: 'var(--error)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
      <div>
        <strong style={{ fontSize: 14 }}>Your account is suspended.</strong>
        <div style={{ fontSize: 12, opacity: 0.85, marginTop: 2 }}>Contact your organization admin to regain access.</div>
      </div>
    </div>
  );
}
